import { Warning } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GenConfirmationDialog } from '../GenDialogs';

export default function WOMultipleOrdersModal({
  open,
  onClose,
  editServices,
  createOrders,
  isLoading,
  numberOfOrders,
}) {
  const { t } = useTranslation('workOrdersTable');
  return (
    <GenConfirmationDialog
      open={open}
      titleIcon={Warning}
      titleIconColor="warning"
      title={t('multipleOrders.title')}
      confirmStartIcon={null}
      closeText={t('multipleOrders.closeText')}
      confirmText={t('multipleOrders.confirmText')}
      onClose={onClose}
      onRefuse={editServices}
      onConfirm={createOrders}
      isLoading={isLoading}
      sx={{
        '& .MuiDialogTitle-root': {
          padding: '0 24px 16px 24px',
        },
        '& .MuiDialogActions-root': {
          padding: '0 16px 16px 16px',
        },
      }}
    >
      <Stack alignItems="center">
        <Typography variant="body1" color="textSecondary">
          {t('multipleOrders.subtitle1')}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {t('multipleOrders.subtitle2')}
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginBottom="20px"
        >
          <Typography variant="overline" color="textSecondary">
            {t('multipleOrders.ordersToCreate')}
          </Typography>
          <Typography variant="subtitle2" marginLeft={'7.5px'}>
            {t('multipleOrders.numberOfOrders', { value: numberOfOrders })}
          </Typography>
        </Box>
      </Stack>
    </GenConfirmationDialog>
  );
}
